import persistentData from "@/plugins/persistentData";
import moment from "moment";
//import { useRouter, useRoute } from 'vue-router';
// import { useStore } from 'vuex';

let intervalRefreshToken = null;

export default {
  state: () => ({
    logged: false,
    user : {},
  }),
  getters: {
    manageUser_logged: state => state.logged,
    manageUser_user: state => state.user,
  },
  
  mutations: { 
    manageUser_setLogged(state, value) {
      state.logged = value;
    },
    manageUser_setUser(state, value) {
      state.user = value;
    },
  },
  actions: {
    manageUser_active({ commit, dispatch }) {
      if (persistentData.get('token')) {
        // Validate tokenExpiration
        const validateToken = async function() {
          const expiredToken = moment(persistentData.get('tokenExpiration')).diff(moment());
          if (expiredToken < 0) {
            try {
              const request = await dispatch('security_refreshToken', {value: persistentData.get('token')});
              if (request.status === 200) {
                persistentData.set('token', request.data.token);
                persistentData.set('tokenExpiration', request.data.tokenExpiration);
              } else {
                dispatch('manageUser_disabled');
              }
            } catch (error) {
              dispatch('manageUser_disabled');
            }
          }
        }

        validateToken();
        if (intervalRefreshToken) clearInterval(intervalRefreshToken)
        
        intervalRefreshToken = setInterval(() => {
          validateToken();
        }, 10000);
        commit('manageUser_setUser', JSON.parse(persistentData.get('user')));
        commit('manageUser_setLogged', true);
      } 
      else {
        /* const router = useRouter();
        const route = useRoute();
        const store = useStore();
        setTimeout(() => {
          if(route.name != 'USER_REGISTRATION')
            //console.log(route.path);
            store.commit('redirectAfterLogin',route.path);
            router.push('/login');
        },0) */
        dispatch('manageUser_disabled');
      }
      let lang = persistentData.get('user',true).countryCode;
      if (['AR', 'CL', 'MX', 'PE', 'UY'].includes(lang)) {
        //window.i18n.global.locale.value = `es-${lang.toUpperCase()}`;
        window.i18n.global.locale.value = 'es';
      } else{
        window.i18n.global.locale.value = 'es';
      }
    },
    manageUser_disabled({ commit }) {
      const storedUser = JSON.parse(persistentData.get('user'));
      persistentData.remove('token');
      persistentData.remove('tokenExpiration');
      persistentData.remove('user');
      if (intervalRefreshToken) clearInterval(intervalRefreshToken);
      commit('manageUser_setLogged', false);
      if(storedUser != null && storedUser != undefined && storedUser.role.toLowerCase() == 'learninguser'){
        window.location.href = process.env.VUE_APP_LMS_SSO_FROM_URL;
        throw new Error('User disabled');
      }
    },
    async manageUser_pickRole({dispatch}, role ){
      let request = await dispatch('security_pickRole', { role: role });
      persistentData.set('token', request.data.token);
      persistentData.set('tokenExpiration', request.data.tokenExpiration);
      persistentData.set('user', JSON.stringify(request.data));
      dispatch('manageUser_active');
    }
  }
}